<!--
   Main nav menu component
 -->
<script setup lang="ts">
/* UTILS */
import { ref } from 'vue';

/* COMPOSABLES */
import { useNavMenu } from '@/composables/useNavMenu';
/* HELPERS */
import { checkExternalRedirect, getMenu } from '@/helpers/navigation';

const navMenu = ref(getMenu('navMenu'));

const { currentTabIndex, updateCurrentTab, itemRoute, isActive } = useNavMenu(navMenu);
</script>

<template>
  <v-tabs v-model="currentTabIndex">
    <v-tab
      v-for="navItem in navMenu"
      :key="navItem.label"
      class="text-body-2 font-weight-regular text-fontPrimary text-capitalize pa-0"
      :to="itemRoute(navItem)"
      @click="checkExternalRedirect(navItem)"
    >
      <div class="px-5">
        <!-- didn't used prepend prop : it will add a padding, an icon was displayed insied the padding -->
        <v-icon v-if="navItem.icon" :icon="navItem.icon" />
        <span class="ms-2">{{ $t(navItem.label) }}</span>
      </div>

      <v-menu
        v-if="navItem.items?.length"
        activator="parent"
        scrollStrategy="close"
        @update:modelValue="updateCurrentTab($event, navItem.label)"
      >
        <v-card :border="0">
          <v-tabs direction="vertical" bgColor="surface" :mandatory="false">
            <v-tab
              v-for="(item, i) in navItem.items"
              :key="i"
              :value="item"
              :to="itemRoute(item)"
              :class="['text-body-3 font-weight-regular', 'py-4', item.class, { 'text-primary': isActive(item) }]"
              :text="$t(item.label)"
              :data-cy="item.datacy ? `nav-bar-${item.datacy}` : undefined"
              :prependIcon="item.icon"
              hideSlider
              @click="checkExternalRedirect(item)"
            >
            </v-tab>
          </v-tabs>
        </v-card>
      </v-menu>
    </v-tab>
  </v-tabs>
</template>
